import type { UrlV2 } from "../models/station.js";

/**
 * A station's playable URLs in the order a player should try them.
 *
 * `fallbackIndex` wins when present; URLs without one keep their array
 * position after the indexed ones. Empty values are dropped. `urls[0]` stays
 * first for V1-shaped docs, so legacy-equivalent behavior is the default.
 */
export function orderedUrls(urls: readonly UrlV2[]): UrlV2[] {
  return urls
    .map((u, i) => ({ u, i }))
    .filter(({ u }) => typeof u.value === "string" && u.value.length > 0)
    .sort((a, b) => {
      const fa = a.u.fallbackIndex ?? Number.POSITIVE_INFINITY;
      const fb = b.u.fallbackIndex ?? Number.POSITIVE_INFINITY;
      if (fa !== fb) return fa - fb;
      return a.i - b.i;
    })
    .map(({ u }) => u);
}
